import { useConformityCounts } from "@/features/material-compliance/api/conformityApi"
import { useQuestionnaireStats } from "@/features/material-compliance/api/customerRequestsApi"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { Inbox } from "lucide-react"
import { useNavigate } from "react-router"
import { StudioCard, type StudioCardStatState } from "./StudioCard"
import { useNumberFormat } from "./useNumberFormat"

export function CustomerStudioCard() {
  const { translate } = useTranslation()
  const navigate = useNavigate()
  const { format, formatOrNull } = useNumberFormat()
  const questionnaires = useQuestionnaireStats()
  const conformity = useConformityCounts()

  const drafts = conformity.data
    ? conformity.data.needsReview + conformity.data.ready
    : undefined
  const stat: StudioCardStatState = conformity.isError
    ? "unavailable"
    : drafts == null
      ? "loading"
      : {
          value: translate("MC_HOME_CUST_STAT_DRAFTS", {
            count: drafts,
            value: format(drafts),
          }),
          caption: translate("MC_HOME_CUST_STAT_CAPTION"),
          tone: drafts > 0 ? "warning" : "success",
        }

  const pending = questionnaires.data?.pending

  return (
    <StudioCard
      icon={Inbox}
      title={translate("MC_TAB_CUSTOMER_STUDIO")}
      question={translate("MC_HOME_CUST_QUESTION")}
      stat={stat}
      statCaption={translate("MC_HOME_CUST_STAT_CAPTION")}
      roleLabel={translate("MC_HOME_CUST_ROLE")}
      badge={
        pending
          ? { count: pending, tooltip: translate("MC_HOME_CUST_BADGE_TIP") }
          : undefined
      }
      backTitle={translate("MC_HOME_CUST_BACK_TITLE")}
      backRows={[
        {
          label: translate("MC_HOME_CUST_ROW_RECEIVED"),
          value: questionnaires.isError
            ? null
            : formatOrNull(questionnaires.data?.received),
        },
        {
          label: translate("MC_HOME_CUST_ROW_PROCESSED"),
          value: questionnaires.isError
            ? null
            : formatOrNull(questionnaires.data?.processed),
        },
        {
          label: translate("MC_HOME_CUST_ROW_READY"),
          value: conformity.isError
            ? null
            : formatOrNull(conformity.data?.ready),
        },
        {
          label: translate("MC_HOME_CUST_ROW_APPROVED"),
          value: conformity.isError
            ? null
            : formatOrNull(conformity.data?.approved),
        },
        {
          label: translate("MC_HOME_CUST_ROW_SENT"),
          value: conformity.isError
            ? null
            : formatOrNull(conformity.data?.sent),
        },
      ]}
      ctaLabel={translate("MC_HOME_CUST_CTA")}
      onOpen={() => navigate("/material-compliance/customer-studio/requests")}
    />
  )
}
